import React from 'react';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import { EArchiveListFilterValues } from '../../../EArchive/Components/EArchiveListFilter/EArchiveListFilter';
import useFilters from '../../../Base/Hooks/useFilters';
import { useAppContext } from '../../../../Services/AppContext';

export interface ManagerInsuranceReportFilterValues {
	doctorId?: string;
}

interface Props {
	onFilter: (values: ManagerInsuranceReportFilterValues) => void;
}

const ManagerInsuranceReportFilter: React.FC<Props> = ({ onFilter }) => {
	const { workplaceId } = useAppContext();
	const { handleSelectValue } = useFilters();

	const onFilterData = (values: any) => {
		const filter: EArchiveListFilterValues = {
			doctorId: handleSelectValue(values?.doctor?.value),
			workplaceId: handleSelectValue(values?.workplaceId?.value) ?? workplaceId,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			defaultValues={{ workplaceId: { value: workplaceId } }}
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.MANAGER_INSURANCE_REPORT_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID}
				width={300}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.WORKPLACE}
				width={330}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default ManagerInsuranceReportFilter;
